import { useState } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { useToast } from '@/hooks/useToast'
import { Modal } from '@/components/Modal/Modal'
import { Input } from '@/components/Input'
import { strings } from '@/strings'

export function NostrReauthModal() {
    const { showNostrReauth, resolveNostrReauth, loginNostr } = useAuth()
    const { showToast } = useToast()
    const [nsec, setNsec] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const handleClose = () => {
        resolveNostrReauth(false)
        setNsec('')
        setError(null)
    }

    const handleConfirm = async () => {
        if (!nsec.trim()) return
        setError(null)
        setLoading(true)
        try {
            await loginNostr('nsec', nsec.trim())
            setNsec('')
            showToast(strings.nostrReauth.successToast, 'success')
            resolveNostrReauth(true)
        } catch {
            setError(strings.nostrReauth.invalidKey)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            isOpen={showNostrReauth}
            onClose={handleClose}
            title={strings.nostrReauth.title}
            confirmLabel={
                loading ? strings.nostrReauth.submittingLabel : strings.nostrReauth.submitLabel
            }
            cancelLabel={strings.nostrReauth.cancelLabel}
            onConfirm={handleConfirm}
            isLoading={loading}
        >
            <p className="mb-4">{strings.nostrReauth.body}</p>
            <Input
                type="password"
                placeholder={strings.nostrReauth.inputPlaceholder}
                value={nsec}
                onChange={e => setNsec(e.target.value)}
                disabled={loading}
                autoComplete="off"
                error={error ?? undefined}
            />
        </Modal>
    )
}
